import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { db } from '../lib/firebase';
import { collection, getDocs } from 'firebase/firestore';
import { GameCard } from '../components/GameCard';
import { Footer } from '../components/Footer';
import { Gamepad2 } from 'lucide-react';

export default function Games() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const gamesSnapshot = await getDocs(collection(db, 'games'));
        const gamesData = gamesSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setGames(gamesData);
      } catch (error) {
        console.error('Error fetching games:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050000] pt-20 flex items-center justify-center">
        <div className="animate-spin w-12 h-12 border-4 border-[#D90429] border-t-transparent rounded-full" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-dark pt-20">
      <section className="py-16 px-4" data-testid="games-page">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl font-montserrat font-bold text-white mb-4">
              Bütün Oyunlarımız
            </h1>
            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Hər oyun unikal hekayə və qorxu təcrübəsi təklif edir. Hansı qorxuya cəsarət edəcəksən?
            </p>
          </motion.div>

          {games.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
              {games.map((game, index) => (
                <GameCard key={game.id} game={game} index={index} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <Gamepad2 className="w-20 h-20 text-gray-600 mx-auto mb-6" />
              <h3 className="text-2xl text-white mb-3">Hələ oyun əlavə edilməyib</h3>
              <p className="text-gray-400">Admin paneldən oyun əlavə edin</p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
